import tree from '@/components/tree.vue'
import DelData from '@/components/delToast.vue'
import { dqgj } from '@/axios'
import Page from '@/components/page.vue'
import { Message } from 'element-ui'
import myTables from '@/components/tables/tables.vue'
let that;
export default{
	data(){
		return{
			getdata:{
				user_id:this.$store.state.user.userinfo.id,
				flag:this.$store.state.user.userinfo.flag,
				tid:4,//书记信箱 
				title:"",
				year:'',
				month:"",
				page:1,
			},
			tableHeader: [     // 表头
				{prop: 'title', label: '标题',width:""},
				{prop: 'class_id', label: '分类',width:"80",formatData:(val) => {
					if(val == 1){
						return '建言献策'
					}else if(val == 2){
						return '匿名投诉'
					}else{
						return '未知分类'
					}
				}},
				{prop: 'is_feedback', label: '状态',width:"80"},
				{prop: 'k_time', label: '发布时间',width:"160"},
				// 操作栏
				{
					prop: 'oper', label: '操作', fixed: 'right', width: '125',
					oper: [
						{name: "详情", style: {color:'#bb0000'}, clickFun: this.detail},
						{name: '删除', style: {color:'#bb0000'}, clickFun: this.del},
					]
				}
			],
			delList:[],
			tableData:[],
			totalPage:0,
		}
	},
	components:{tree,Page,DelData,myTables},
	methods:{
		// 数据
		dataList(){
			dqgj.dqgjList(that.getdata).then(res => {
				that.tableData = res.data.pagedata;
				that.totalPage = res.data.count;
			})
		},
		// 一键删除
		selectList(val){
			that.delList = val;
		},
		delAll(){
			if(that.delList.length == 0){
				Message.warning('请先选择要删除得数据')
			}else{
				that.delData();
			}
		},
		//	删除操作
		delData(){
			that.$refs.delData.showToast(res => {
				if(res){
					dqgj.dqgjDel({
						id:data.id
					}).then(res => {
						if(res.code == 200){
							Message({
								type: 'success',
								message: '删除成功!'
							})
						}else{
							Message({
								type: 'error',
								message: res.msg
							})
						}
						that.getdata.page = 1;
						that.dataList();
					})
				}else{
					
				}
			})
		},
		del(data){
			that.delList = [data.id]
			that.delData();
		},
		detail(data){
			// 详情
			that.$router.push({
				path:"/sjxx_detail",
				query:{
					id:data.id,
					flag:that.getdata.flag,
					user_id:that.getdata.user_id
				}
			})		
		},
		// 分页筛选
		changedata(current){
			that.getdata.page = current;
			that.dataList();
		},
		// 树形结构筛选
		treeSelect(data){
			that.getdata.user_id = data.id;
			that.getdata.flag = data.flag;
			that.getdata.page = 1;
			that.dataList();
		}
	},
	mounted() {
		that.dataList();
	},
	created() {
		that = this;
		that.$emit('selectTop',2)
	}
}